import React from 'react';
import { graphql, withApollo } from 'react-apollo';
import subirDocumento from '../../../../graphql/mutations/arreglosExtrajudiciales/subirDocumento.graphql';
import agregarDocumento from '../../../../graphql/mutations/arreglosExtrajudiciales/agregarDocumento.graphql';
import { Upload, Row, Col, Spin, Button, Input, notification } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { Form } from '@ant-design/compatible';

@graphql(subirDocumento, {
  name: 'subirDocumento',
})
@graphql(agregarDocumento, {
  name: 'agregarDocumento',
})
class Uploader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fileList: [],
      titulo: '',
      uploading: false,
    };
  }

  guardarDocumento = file => {
    this.props
      .subirDocumento({
        variables: {
          objDocumento: {
            nombre: this.state.titulo,
            tramite: 'acuerdo_extrajudicial',
            idTramite: this.props.acuerdo._id,
          },
          archivo: file,
        },
      })
      .then(res => {
        if (res.data.subirDocumento) {
          this.props
            .agregarDocumento({
              variables: {
                _id: this.props.acuerdo._id,
                idDocumento: res.data.subirDocumento._id,
              },
            })
            .then(res => {
              this.props.actualizarTabla();
              notification.success({
                message: 'Documento agregado correctamente',
                description:
                  'El documento se registró correctamente en la base de datos',
              });
            })
            .catch(err => {
              console.log('Error a la hora de agregar el documento al acuerdo');
              console.log(err);
            });
        }
      })
      .catch(err => {
        console.log('ERROR EN INSERTAR DOCUMENTO: ', err);

        notification.error({
          message: 'Error al agregar el documento',
          description: 'Se ha producido un error al agregar el documento',
        });
      });
  };

  handleUpload() {
    const { fileList } = this.state;
    if (!fileList.length) return;

    if (this.state.titulo.length > 0) {
      let all = fileList.map(file => this.guardarDocumento(file));
      Promise.all(all).then(res => {
        this.setState({ uploading: false, fileList: [] });
        if (this.props.onDone) this.props.onDone(all);
      });
      this.setState({ uploading: true });
    } else {
      notification.warning({
        message: 'Debe incluir un titulo al archivo PDF',
      });
    }
  }

  render() {
    const uploadProps = {
      action: this.props.action || this.state.uploadData,
      onRemove: file => {
        this.setState(({ fileList }) => {
          const index = fileList.indexOf(file);
          const newFileList = fileList.slice();
          newFileList.splice(index, 1);
          return {
            fileList: newFileList,
          };
        });
      },
      beforeUpload: file => {
        this.setState(({ fileList }) => ({
          fileList: [...fileList, file],
        }));
        return false;
      },
      fileList: this.state.fileList,
      accept: 'application/pdf',
    };

    return (
      <Form encType="multipart/form-data">
        <Row>
          <Col span={24}>
            <div className="inputs">
              <h3>Titulo: </h3>
              <Input
                id="titulo"
                value={this.state.titulo}
                placeholder="Ingrese el titulo del documento a subir"
                onChange={e =>
                  this.setState({
                    titulo: e.target.value,
                  })
                }
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Upload {...uploadProps}>
              <Button>
                <Icons.UploadOutlined />
                Seleccionar Documento PDF
              </Button>
            </Upload>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <br />
            {this.state.uploading && <Spin tip="Subiendo..." />}
            {!this.state.uploading && this.state.fileList.length > 0 && (
              <Button
                icon={<Icons.UploadOutlined />}
                onClick={this.handleUpload.bind(this)}
                style={{ width: '20em' }}
                type="primary"
              >
                Subir
              </Button>
            )}
          </Col>
        </Row>
      </Form>
    );
  }
}

export default withApollo(Uploader);
